import React, { useEffect, useState, useRef } from "react"
import {
  Badge,
  Container,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown,
} from "reactstrap"
import Breadcrumbs from "../../../components/Common/Breadcrumb"
import { Link, useNavigate } from "react-router-dom"
import { useMemo } from "react"
import { useTable } from "react-table"
import {
  Table,
  Row,
  Col,
  Card,
  CardBody,
  Modal,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
} from "reactstrap"
import classnames from "classnames"

import ProposalPdf from "./ProposalPdf"

// for pdf
// assets
import "../../../assets/css/Sales/Sales.css"
import "../../../assets/css/Sales/Proposal.css"
import zithasLogo from "../../../assets/images/zithas-dark-logo.png"
import AccessDenied from "../../../assets/images/dribbble_1.gif"

// common component
import Pagination from "components/Common/Pagination"
import sideImg from "../../../assets/images/profile-img.png"
import InfoGif from "../../../assets/images/GIF/question-mark.gif"
// components
import ViewProfile from "./ViewProposal/ViewProfile"
import ViewActivity from "./ViewProposal/ViewActivity"
import axios from "axios"
import moment from "moment"
import Loader from "pages/Separate/Loader"
import swal from "sweetalert"
import RevisionHistory from "./EditProposal/RevisionHistory"
import ViewRevision from "./ViewProposal/ViewRevision"
import configure from "configure"
import AccessDeniedPopup from "routes/AccessDeniedPopup"
import { FetchNodePostData } from "utils/common-fetchData"
import CopyToClipboard from "react-copy-to-clipboard";
import ProposalPdfBlank from "./ProposalPdfBlank"

function TableContainer({
  columns,
  data,
  setAccessDenied,
  statusCounts,
  pageIndex,
  pageSize,
  pageOptions,
  canPreviousPage,
  canNextPage,
  gotoPage,
  previousPage,
  nextPage,
  onPageSizeChange,
  search,
  onSearchChange,
}) {
  const [fixedContent, setFixedContent] = useState(false)

  const navigate = useNavigate()

  document.addEventListener("scroll", () => {
    if (window.scrollY > 165) {
      setFixedContent(true)
    } else {
      setFixedContent(false)
    }
  })

  // Data is already the current server-side page, so no pagination/filter plugins here
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    })

  const statusCount = statusName =>
    statusCounts?.find(s => s.status_name === statusName)?.count || 0

  const [name_modal, setNameModal] = useState(false)
  const [title, setTitle] = useState("")

  const info = [
    {
      title: "Assigned",
      mean: " <p> <strong>Meaning :</strong> In the Mars System's Lead Module, the <strong>Assigned </strong> column designates the specific team member or individual responsible for overseeing and taking action on a lead or potential business opportunity. </p>",
      purpose:
        " <p> <strong>Purpose :</strong> The purpose of the <strong>Assigned</strong> column in the Lead Module is to assign clear accountability for each lead. By identifying who is responsible for nurturing and converting leads into customers, it streamlines lead management, ensures follow-up, and enhances the chances of successful lead conversion. This fosters a more efficient and organized approach to lead handling within the Mars System.</p>",
    },
    {
      title: "Name",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Name</strong> column represents the name of the customer or organization for whom the proposal is being prepared.</p>",
      purpose:
        "<p> <strong>Purpose :</strong> The purpose of the <strong>Name</strong>  column is to provide specific identification of the recipient of the proposal. It ensures that each proposal is customized and addressed to the correct customer or organization, creating a personalized and professional impression. This column is crucial for accurate proposal documentation and effective communication within the Mars System, helping to build strong customer relationships and tailor proposals to individual needs.</p>",
    },
    {
      title: "Type",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Type</strong>  column categorizes proposals into distinct types, such as <strong>General</strong>, <strong>Website</strong>, <strong>SEO </strong>, <strong>Digital Marketing</strong>, or <strong>Dedicated Resource.</strong> </p>",
      purpose:
        "</strong> <p> <strong>Purpose :</strong> The purpose of the <strong>Type</strong> column is to provide specific information about the person linked to the lead. It allows for personalized communication and relationship-building with leads. By knowing the names of potential clients or contacts, the Mars System's users can establish a more personal and targeted approach to lead engagement, which can significantly improve lead conversion rates and customer satisfaction</p>",
    },
    {
      title: "Currency",
      mean: "<p><strong>Meaning :</strong> In the Mars System's Proposal Module, the  <strong>Currency</strong> column specifies the currency in which the proposal's pricing and financial details are presented.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Currency</strong> column is to provide clarity and transparency regarding the currency in which the proposal's costs and pricing are expressed. This ensures that both your team and the client understand the financial terms of the proposal. By clearly indicating the currency, you facilitate accurate pricing and financial communication, especially in international or multi-currency transactions within the Mars System.</p>",
    },
    {
      title: "Price",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong>Price</strong> column denotes the total cost or pricing details associated with the proposal, which may include itemized costs for services, products, or any other expenses.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Price</strong>  column is to provide a clear and itemized breakdown of the costs associated with the proposal. It allows both your team and the client to understand the financial aspects of the proposal, making it easier to review and negotiate terms. This column ensures transparency in pricing and supports informed decision-making within the Mars System, helping to reach agreements that align with both parties' expectations.</p>",
    },
    {
      title: "Created At",
      mean: " <p><strong>Meaning :</strong> In the Mars System's Proposal Module, the <strong>Created At</strong> column records the date and time when the proposal was initially created or entered into the system.</p>",
      purpose:
        "<p><strong>Purpose :</strong> The purpose of the <strong>Created At</strong> column is to track and document the proposal's creation timeline. It provides valuable information about the proposal's age and origin, allowing users to gauge its recency and relevance. This column aids in organizing proposals chronologically, assessing the efficiency of the proposal creation process, and ensuring that proposals are up-to-date and timely managed within the Mars System.</p>",
    },
    {
      title: "Open Till",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong> Open Till</strong>column signifies the date until which the proposal remains valid and open for consideration by the client.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong> Open Till</strong> column is to establish a clear expiration date for the proposal's validity. It ensures that both your team and the client are aware of the timeframe within which the proposal can be accepted or negotiated. This column helps manage proposal timelines, avoid misunderstandings, and maintain accurate records of proposal status within the Mars System.</p>",
    },
    {
      title: "Status",
      mean: "<p><strong>Meaning :</strong>  In the Mars System's Proposal Module, the <strong>Status</strong> column categorizes proposals into different stages, including <strong>In Progress </strong>, <strong>On Hold </strong>, <strong>Lost </strong>, or <strong>Won </strong>.</p>",
      purpose:
        "<p><strong>Purpose :</strong>  The purpose of the  <strong>Status</strong> column is to provide a quick overview of the current state of each proposal. It helps users track and manage the progression of proposals, from creation to closure. By categorizing proposals into these stages, the Mars System facilitates efficient proposal management, allowing teams to focus their efforts on active proposals, prioritize follow-ups, and accurately report on the status of each proposal. This column aids in effective decision-making and resource allocation.</p>",
    },
  ]

  const [viewData, setViewData] = useState(false)
  const [isLoading, setLoading] = useState(false)
  const [currency_data, setCurencyData] = useState([])

  // const onProposalData = async e => {
  //   setViewData(true)
  //   setLoading(true)
  //   try {
  //     const response = await axios({
  //       method: "get",
  //       url: "https://mars.ztpl.net/api/proposal_currency_count",
  //       headers: {
  //         Accept: "application/json",
  //         "Content-Type": "multipart/form-data",
  //       },
  //     }).then(response => {
  //        console.log(response)
  //       setCurencyData(response.data.data)
  //       setLoading(false)
  //     })
  //   } catch (err) {
  //     console.log(err)
  //     setLoading(false)
  //   }
  // }
  // console.log(currency_data)

  const onAddPermission = async id => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("module_id", 19)
    try {
      await axios({
        method: "post",
        url: `${configure.nodeApi}/user_permission`,
        data: formData,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }).then(res => {
        if (res.data.data.india[3] == 1 || res.data.data.uk[3] == 1) {
          navigate(`${configure.appUrl}sales/add-proposal`)
        } else {
          setAccessDenied(true)
        }
        setLoading(false)
      })
    } catch (error) {
      console.log(error)
      setLoading(false)
    }
  }
  // Render the UI for your table
  return (
    <div>
      {isLoading && <Loader />}
      {/* fixed buttons */}
      <div
        className={`flex-column fixed-buttons pt-2 ${fixedContent ? "d-flex" : "d-none"
          }`}
      >
        <Link
          // to={`${configure.appUrl}sales/add-proposal`}
          onClick={() => onAddPermission()}
          className="btn btn-save s fix-btn btn-label pe-0"
        >
          <i className="fas fa-plus me-2 icon-size label-icon"></i>
          <span>Proposal</span>
        </Link>
        <button
          onClick={() => navigate(-1)}
          className="btn btn-red s fix-btn btn-label pe-0"
        >
          <i className="dripicons-cross me-2 icon-center label-icon"></i>
          <span>Cancel</span>
        </button>
      </div>
      <Row className="mb-4 align-items-center">
        <Col md={5} className="pr-0">
          <div className="d-flex justify-content-between align-items-center">
            {/* counts */}
            <div className="d-flex justify-content-between w-100 text-center align-items-center">
              <a
                href="#"
                className="text-secondary pt-2 px-2 rounded proposal-status"
              >
                <h4>{statusCount("Draft")}</h4>
                <h4>Draft</h4>
              </a>
              <a
                href="#"
                className="text-primary pt-2 px-2 rounded proposal-status"
              >
                <h4> {statusCount("Sent")}</h4>
                <h4>Sent</h4>
              </a>
              <a
                href="#"
                className="text-danger pt-2 px-2 rounded proposal-status"
              >
                <h4>{statusCount("Lost")}</h4>
                <h4>Lost</h4>
              </a>
              <a
                href="#"
                className="text-success pt-2 px-2 rounded proposal-status"
              >
                <h4>{statusCount("Won")}</h4>
                <h4>Won</h4>
              </a>
              <a
                className="button-info-proposal bg-primary"
              // onClick={onProposalData}
              >
                <i className="bx bx-info-circle"></i>
              </a>
            </div>
          </div>
        </Col>
        <Col
          md={7}
          className="d-flex align-items-center justify-content-end pl-0"
        >
          <div>
            <select
              className="s me-4 form-select"
              style={{ width: "100px" }}
              value={pageSize}
              onChange={e => onPageSizeChange(Number(e.target.value))}
            >
              {[10, 25, 50, 100].map(size => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </div>
          <div className="me-4 mt-10">
            <div className="search-box">
              <div className="position-relative">
                <label htmlFor="search-bar-0" className="search-label">
                  <span id="search-bar-0-label" className="sr-only">
                    Search this table
                  </span>
                  <input
                    onChange={e => onSearchChange(e.target.value)}
                    id="search-bar-0"
                    type="text"
                    className="s form-control rounded "
                    placeholder={` Search...`}
                    value={search || ""}
                  />
                </label>
                <i className="bx bx-search-alt search-icon"></i>
              </div>
            </div>
          </div>
          <div className="text-md-end">
            <Link
              // to={`${configure.appUrl}sales/add-proposal`}
              onClick={() => onAddPermission()}
              className="s btn text-white me-2 btn-save btn-label"
            >
              <i className="fas fa-plus me-2 icon-size label-icon"></i>Proposal
            </Link>
            <button
              onClick={() => navigate(-1)}
              className="s btn btn-red btn-label"
            >
              <i className="dripicons-cross me-2 icon-center label-icon"></i>
              CANCEL
            </button>
          </div>
        </Col>
      </Row>
      <div className="position-relative">
        <Table className="table table-bordered" {...getTableProps()}>
          <thead
            className={`${fixedContent ? "fix-header" : ""
              } fix-proposal-header`}
          >
            {headerGroups.map((headerGroup, i) => (
              <tr key={i} {...headerGroup.getHeaderGroupProps()}>
                {headerGroup.headers.map((column, index) => (
                  <th
                    key={index}
                    className={`t-col-${index + 1} ${column.className}`}
                    {...column.getHeaderProps()}
                  >
                    {column.render("Header")}
                    {column.isInfoIcon ? (
                      <a
                        onClick={() => {
                          setNameModal(true)
                          setTitle(column.Header)
                        }}
                      >
                        <i
                          title="info"
                          className="bx bx-info-circle ms-1 info-icon"
                        ></i>
                      </a>
                    ) : null}
                  </th>
                ))}
              </tr>
            ))}
          </thead>

          <tbody className="fix-proposal-header" {...getTableBodyProps()}>
            {rows.map((row, i) => {
              prepareRow(row)
              let rowColor
              switch (row.original.status_name) {
                case "Won":
                  rowColor = "bg-green"
                  break
                case "Draft":
                  rowColor = "bg-gray"
                  break
                case "Lost":
                  rowColor = "bg-red"
                  break
                case "Sent":
                  rowColor = "bg-blue"
                  break
              }
              return (
                <tr
                  className={`row-hover ${rowColor}`}
                  {...row.getRowProps()}
                  key={i}
                >
                  {row.cells.map((cell, index) => {
                    return (
                      <td
                        key={index}
                        className={`t-col-${index + 1} ${cell.column.className
                          }`}
                        {...cell.getCellProps()}
                      >
                        {cell.render("Cell")}
                      </td>
                    )
                  })}
                </tr>
              )
            })}
          </tbody>
        </Table>
      </div>

      {/* Pagination */}
      <Row className="justify-content-md-end justify-content-center align-items-center">
        <Pagination
          gotoPage={gotoPage}
          previousPage={previousPage}
          canPreviousPage={canPreviousPage}
          nextPage={nextPage}
          canNextPage={canNextPage}
          pageIndex={pageIndex}
          pageOptions={pageOptions}
        />
      </Row>

      <Modal
        isOpen={name_modal}
        toggle={() => {
          tog_center()
        }}
        className="bd-info-popup"
        centered
      >
        <div className="modal-header bd-head-info">
          <h5 className="modal-title mt-0">
            <i className="dripicons-information bd-transform-icon pr-10 text-red"></i>
            {title}
          </h5>
        </div>
        <div className="modal-body pb-0">
          <div className="d-flex">
            <div className="col-5 pr-30">
              <div>
                <img src={InfoGif} className="w-100" />
              </div>
            </div>
            <div className="mt-20 ">
              <div>
                {info.map((item, i) => {
                  if (item.title == title) {
                    return (
                      <div key={i}>
                        <span>
                          <span
                            dangerouslySetInnerHTML={{ __html: item.mean }}
                          ></span>
                        </span>
                        <div
                          dangerouslySetInnerHTML={{ __html: item.purpose }}
                        ></div>
                      </div>
                    )
                  }
                })}
                <div></div>
                <div className="text-center mt-70">
                  <button
                    type="button"
                    className="btn btn-success "
                    onClick={() => setNameModal(false)}
                  >
                    I Understood
                    <i className="dripicons-thumbs-up pl-10"></i>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      <Modal size="md" centered isOpen={viewData} className="activity-log">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Log Details</h5>
          <button
            type="button"
            onClick={() => {
              setViewData(false)
            }}
            className="btn-modal-close"
          >
            <span aria-hidden="true" className="btn-modal-span">
              &times;
            </span>
          </button>
        </div>
        <div className="modal-body">
          <div className="table-responsive">
            <table className="table mb-0 table">
              <thead className="table-light">
                <tr>
                  <th>Currency</th>
                  <th>Draft</th>
                  <th>Sent</th>
                  <th>Lost</th>
                  <th>Won</th>
                </tr>
              </thead>
              <tbody>
                {/* {viewData.map((items, index) => {
                  return (
                    <tr key={index}>
                      <th scope="row">{items}</th>
                      <td>
                        <div
                          className="no-padding-desc"
                          dangerouslySetInnerHTML={{
                            __html: oldValue[index],
                          }}
                        />
                      </td>
                      <td>

                      </td>
                    </tr>
                  )
                })} */}
              </tbody>
            </table>
          </div>
        </div>
      </Modal>
    </div>
  )
}

const Proposal = () => {
  const [verticalActiveTab, setverticalActiveTab] = useState("1")
  const [modal_fullscreen, setmodal_fullscreen] = useState(false)
  const [copyMsg, setCopyMsg] = useState("");
  const [copiedId, setCopiedId] = useState(null);
  const [responseModal, setResponseModal] = useState(false);
  const [selectedResponse, setSelectedResponse] = useState(null);

  const toggleVertical = tab => {
    if (verticalActiveTab !== tab) {
      setverticalActiveTab(tab)
    }
  }

  document.addEventListener("keydown", e => {
    if (e.key === "Escape") setmodal_fullscreen(false)
  })

  //meta title
  document.title = "Proposal | Zithas Technologies"

  const [data, setDatas] = useState([])
  const [view_proposal, setViewProposal] = useState([])
  const [isLoading, setLoading] = useState(false)
  const [statusCounts, setStatusCounts] = useState([])

  // server-side pagination state
  const [pageIndex, setPageIndex] = useState(0)
  const [pageSize, setPageSize] = useState(50)
  const [totalCount, setTotalCount] = useState(0)
  const pageCount = Math.max(Math.ceil(totalCount / pageSize), 1)
  const [searchInput, setSearchInput] = useState("")
  const [debouncedSearch, setDebouncedSearch] = useState("")

  // debounce the search box, resetting to the first page on every new term
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchInput)
      setPageIndex(0)
    }, 400)
    return () => clearTimeout(timer)
  }, [searchInput])

  useEffect(() => {
    fetch()
  }, [pageIndex, pageSize, debouncedSearch])

  const fetch = async () => {
    setLoading(true)
    const formData = new FormData()
    formData.append("user_id", localStorage.getItem("auth_id"))
    formData.append("page", pageIndex + 1)
    formData.append("limit", pageSize)
    formData.append("search", debouncedSearch)

    try {
      const response = await FetchNodePostData(setLoading, 'proposal', '', formData)

      if (response.data?.success) {
        setDatas(response.data.data.proposal || [])
        setStatusCounts(response.data.data.statusCounts || [])
        setTotalCount(response.data.pagination?.total || 0)
      }
    } catch (err) {
      console.log(err)
      setLoading(false)
    }
  }

  // columns below is memoized with [] deps, so it closes over these refs
  // rather than stale state/closures
  const fetchRef = useRef(fetch)
  useEffect(() => {
    fetchRef.current = fetch
  })

  // removes a proposal from the current page in-place (no refetch) after a
  // delete, keeping the count badges and total in sync with it
  const removeProposalLocally = id => {
    setDatas(prev => {
      const removed = prev.find(item => item.id === id)
      const next = prev.filter(item => item.id !== id)

      if (removed) {
        setStatusCounts(prevCounts =>
          prevCounts.map(s =>
            s.status_name === removed.status_name
              ? { ...s, count: Math.max(Number(s.count) - 1, 0) }
              : s
          )
        )
      }

      // current page emptied out and it's not the first page: step back,
      // which triggers a fresh fetch for the new current page
      if (next.length === 0 && pageIndex > 0) {
        setPageIndex(pageIndex - 1)
      }

      return next
    })
    setTotalCount(prev => Math.max(prev - 1, 0))
  }
  const removeProposalLocallyRef = useRef(removeProposalLocally)
  useEffect(() => {
    removeProposalLocallyRef.current = removeProposalLocally
  })

  const pageOptions = useMemo(
    () => Array.from({ length: pageCount }, (_, i) => i),
    [pageCount]
  )
  const canPreviousPage = pageIndex > 0
  const canNextPage = pageIndex < pageCount - 1
  const gotoPage = idx =>
    setPageIndex(Math.min(Math.max(idx, 0), Math.max(pageCount - 1, 0)))
  const previousPage = () => gotoPage(pageIndex - 1)
  const nextPage = () => gotoPage(pageIndex + 1)
  const onPageSizeChange = size => {
    setPageSize(size)
    setPageIndex(0)
  }

  const [proposal_activity, setProposalActivity] = useState([])
  const [proposal_revision, setProposalRevision] = useState([])
  const [modal_Access, setAccessDenied] = useState(false)
  const navigate = useNavigate()
  const columns = useMemo(
    () => [
      {
        Header: "ID",
        accessor: "id",
        isInfoIcon: false,
        className: "text-center",
      },
      {
        Header: "Assigned",
        accessor: "assign",
        Cell: cellProps => {
          return (
            <div className="text-center d-flex align-items-center">
              <div className="profileImg-box">
                <img
                  src={`https://mars.zithas.com/application/public/${cellProps.row.original.assigned_avatar}`}
                  alt=""
                  className="assigned-img mx-1"
                  height="20"
                  width="20"
                />
                <div className="profileImg-detail">
                  <div className="overflow-hidden mb-0 card">
                    <div className="bg-primary bg-soft">
                      <div className="row">
                        <div className="col-8">
                          <div className="text-primary text-start p-3">
                            <h5 className="text-primary ">
                              {cellProps.row.original.assigned}
                            </h5>
                            <p style={{ width: "200px" }}>
                              {cellProps.row.original.assigned_designation}
                            </p>
                          </div>
                        </div>
                        <div className="align-self-end col-4">
                          <img src={sideImg} alt="" className="img-fluid" />
                        </div>
                      </div>
                    </div>
                    <div className="pt-0 mb-0 card-body">
                      <div className="row">
                        <div className="col-sm-12">
                          <div className="avatar-md profile-user-wid mb-2">
                            <img
                              src={`https://mars.zithas.com/application/public/${cellProps.row.original.assigned_avatar}`}
                              alt=""
                              style={{ width: "100%", height: "100%" }}
                              className="img-thumbnail rounded-circle"
                            />
                          </div>
                        </div>
                        <div className="col-sm-12">
                          <div className=" text-start">
                            <div className="row">
                              <div className="pe-1 col-5">
                                <h5 className="font-size-12 mb-1">Join Date</h5>
                                <p className=" font-size-12 text-muted mb-0">
                                  {moment(
                                    cellProps.row.original?.assigned_joiningdate
                                  ).format("DD-MM-YYYY")}
                                </p>
                              </div>
                              <div className="ps-0 col-7">
                                <h5 className="font-size-12 mb-1">Email</h5>
                                <p className=" font-size-12 text-muted mb-0">
                                  {cellProps.row.original.assigned_email}
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {cellProps.row.original.location == "India" ? (
                <img
                  src="https://mars.zithas.com/assets/images/india.png"
                  className=" mx-1 location-img"
                  alt="flag"
                  height="15"
                  width="20"
                />
              ) : (
                <img
                  src="https://mars.zithas.com/assets/images/uk.png"
                  className=" mx-1 location-img"
                  alt="flag"
                  height="15"
                  width="20"
                />
              )}
            </div>
          )
        },
        isInfoIcon: true,
      },
      {
        Header: "Client Name",
        accessor: "companyname",
        isInfoIcon: true,
      },
      {
        Header: "Proposal Title",
        accessor: "proposaltitile",
        isInfoIcon: true,
        Cell: cellProps => {
          return (
            <span className="text-dark">
              {cellProps.row.original.proposaltitile}
            </span>
          )
        },
      },
      {
        Header: "Type",
        accessor: "type",
        isInfoIcon: true,
      },
      {
        Header: "Price",
        accessor: "price",
        isInfoIcon: true,
        Cell: cellProps => {
          const array = JSON.parse(cellProps.row.original?.costbreakdown)
          const totalSum = array?.reduce((accumulator, item) => {
            const totalValue = parseFloat(item.totalcost) // Convert "total" to a number
            if (!isNaN(totalValue)) {
              return accumulator + totalValue
            }
            return accumulator // Skip items with invalid "total" values
          }, 0)
          return (
            <div>
              {cellProps.row.original.currency} {totalSum || 0}
            </div>
          )
        },
      },
      {
        Header: "Created At",
        accessor: "created_at",
        isInfoIcon: true,
        Cell: cellProps => {
          return (
            <div>
              {moment(cellProps.row.original.created_at.slice(0, 10)).format(
                "DD-MM-YYYY"
              )}
            </div>
          )
        },
      },
      {
        Header: "Open Till",
        accessor: "opentill",
        isInfoIcon: true,
        Cell: cellProps => {
          return (
            <span>
              {moment(cellProps.row.original.opentill).format("DD-MM-YYYY")}
            </span>
          )
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: cellProps => {
          return (
            <span className={cellProps.row.original.status_color + " badge"}>
              {cellProps.row.original.status_name}
            </span>
          )
        },
        isInfoIcon: true,
      },
      {
        Header: "Action",
        accessor: "action",
        Cell: cellProps => {
          const onPermission = async (e, id) => {
            e.preventDefault()
            setLoading(true)
            const formData = new FormData()
            formData.append("user_id", localStorage.getItem("auth_id"))
            formData.append("module_id", 19)
            try {
              await axios({
                method: "post",
                url: `${configure.nodeApi}/user_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }).then(res => {
                if (res.data.data.india[5] == 1 || res.data.data.uk[5] == 1) {
                  onDeleteLead()
                } else {
                  setAccessDenied(true)
                }
                setLoading(false)
              })
            } catch (error) {
              console.log(error)
              setLoading(false)
            }
          }

          const onDeleteLead = e => {
            swal({
              title: "Are you sure?",
              text: "You want to Delete this Proposal !",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then(async willDelete => {
              if (willDelete) {
                setLoading(true)
                const formData = new FormData()
                formData.append("user_id", localStorage.getItem("auth_id"))
                formData.append("proposal_id", cellProps.row.original.id)
                try {
                  const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/delete_proposal`,
                    data: formData,
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }).then(response => {
                    swal({
                      icon: "success",
                      text: "Proposal Deleted Successfully",
                    }).then(() => {
                      removeProposalLocallyRef.current(cellProps.row.original.id)
                    })
                    setLoading(false)
                  })
                } catch (err) {
                  swal({
                    icon: "error",
                    text: "SomeThing Went Wrong",
                  })
                  setLoading(false)
                }
              }
            })
          }

          const viewData = async e => {
            setViewProposal([cellProps.row.original])
            setmodal_fullscreen(true)
            setLoading(true)
            const formData = new FormData()
            formData.append("proposal_id", cellProps.row.original.id)
            try {
              const response = await axios({
                method: "post",
                url: `${configure.nodeApi}/proposal_data`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }).then(response => {
                setProposalActivity(response.data.data.propsal_activity)
                setProposalRevision(response.data.data.proposal_revision)
                setLoading(false)
              })
            } catch (err) {
              swal({
                icon: "error",
                text: "SomeThing Went Wrong",
              })
              setLoading(false)
            }
          }

          const onClone = async e => {
            swal({
              title: "Are you sure?",
              text: "You want to Clone this Proposal !",
              icon: "warning",
              buttons: true,
              dangerMode: true,
            }).then(async willDelete => {
              if (willDelete) {
                setLoading(true)
                const formData = new FormData()
                formData.append("proposal_id", cellProps.row.original.id)
                try {
                  const response = await axios({
                    method: "post",
                    url: `${configure.nodeApi}/clone_proposal`,
                    data: formData,
                    headers: {
                      Accept: "application/json",
                      "Content-Type": "application/json",
                    },
                  }).then(response => {
                    swal({
                      icon: "success",
                      text: "Proposal Cloned Successfully",
                    }).then(() => {
                      fetchRef.current()
                      window.open(
                        `${configure.appUrl}sales/edit-proposal/${response.data.data.res_id}`,
                        "_blank"
                      )
                    })
                    setLoading(false)
                  })
                } catch (err) {
                  swal({
                    icon: "error",
                    text: "SomeThing Went Wrong",
                  })
                  setLoading(false)
                }
              }
            })
          }
          const onEditPermission = async ({ id }) => {
            setLoading(true)
            const formData = new FormData()
            formData.append("user_id", localStorage.getItem("auth_id"))
            formData.append("module_id", 19)
            try {
              await axios({
                method: "post",
                url: `${configure.nodeApi}/user_permission`,
                data: formData,
                headers: {
                  Accept: "application/json",
                  "Content-Type": "application/json",
                },
              }).then(res => {
                if (res.data.data.india[4] == 1 || res.data.data.uk[4] == 1) {
                  navigate(
                    `${configure.appUrl}sales/edit-proposal/${cellProps.row.original.id}`
                  )
                } else {
                  setAccessDenied(true)
                }
                setLoading(false)
              })
            } catch (error) {
              console.log(error)
              setLoading(false)
            }
          }

          return (
            <div className="d-flex">
              <a
                className="btn btn-sm btn-outline-secondary me-1"
                title="View Proposal"
                onClick={viewData}
              >
                <i className="fas fa-eye "></i>
              </a>
              {/* <a className="btn btn-sm btn-outline-secondary me-1">
                <i className="fa fa-file-pdf"></i>
              </a> */}
              {cellProps.row.original.template == "2" ? (
                <ProposalPdfBlank proposal_id={cellProps.row.original.id} />
              ) : (
                <ProposalPdf proposal_id={cellProps.row.original.id} />
              )}

              <UncontrolledDropdown
                className="dropdown"
                style={{ width: "29px" }}
              >
                <DropdownToggle
                  className="btn btn-sm btn-outline-secondary w-100"
                  color="white"
                >
                  <i className="mdi mdi-dots-horizontal"></i>
                </DropdownToggle>
                <DropdownMenu className="dropdown-menu-end">
                  <Link
                    onClick={() =>
                      onEditPermission({ id: cellProps.row.original.id })
                    }
                    title="Edit Proposal"
                    className="dropdown-item"
                  >
                    <i className="fas fa-pencil-alt pr-10"></i> Edit Proposal
                  </Link>
                  {cellProps.row.original.junk_link && (
                    <CopyToClipboard
                      text={`https://mars.zithas.in/sales/proposal/${encodeURIComponent(cellProps.row.original.junk_link)}`}
                      onCopy={() => {
                        setCopyMsg(cellProps.row.original.id);
                        setTimeout(() => setCopyMsg(""), 1500);
                      }}
                    >
                      <button className="dropdown-item copyBtn">
                        <i className="fas fa-link pr-10"></i>
                        Copy Link
                      </button>
                    </CopyToClipboard>
                  )}
                  <a
                    onClick={onClone}
                    title="Clone Proposal"
                    className="dropdown-item"
                  >
                    <i className="fas fa-clone pr-10"></i> Clone Proposal
                  </a>

                  <a
                    onClick={onPermission}
                    title="Delete"
                    className="dropdown-item"
                  >
                    <i className="fas fa-trash-alt text-danger pr-10"></i>{" "}
                    Delete Proposal
                  </a>
                </DropdownMenu>
              </UncontrolledDropdown>
            </div>
          )
        },
      },
    ],
    []
  )

  return (
    <React.Fragment>
      {isLoading && <Loader />}
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title={"Dashboard"} breadcrumbItem={"Proposal"} />
          <Row>
            <Col lg={12} className="p-0">
              <Card>
                <CardBody>
                  <div className="responsive-table">
                    <TableContainer
                      columns={columns}
                      data={data}
                      setAccessDenied={setAccessDenied}
                      statusCounts={statusCounts}
                      pageIndex={pageIndex}
                      pageSize={pageSize}
                      pageOptions={pageOptions}
                      canPreviousPage={canPreviousPage}
                      canNextPage={canNextPage}
                      gotoPage={gotoPage}
                      previousPage={previousPage}
                      nextPage={nextPage}
                      onPageSizeChange={onPageSizeChange}
                      search={searchInput}
                      onSearchChange={setSearchInput}
                    />
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>

      <Modal
        size="xl"
        isOpen={modal_fullscreen}
        toggle={() => {
          tog_fullscreen()
        }}
        className="modal-fullscreen"
      >
        <div className="modal-header mb-0">
          <div
            className="d-flex align-items-center justify-content-between"
            style={{ width: "100%" }}
          >
            <h5 className="col-6 modal-title mt-0">Proposal Details</h5>
          </div>

          <button
            type="button"
            onClick={() => {
              setmodal_fullscreen(false)
            }}
            className="ms-4"
            style={{ border: "none", backgroundColor: "transparent" }}
          >
            <span
              aria-hidden="true"
              style={{ color: "#bf1e30", fontSize: "28px", lineHeight: "1px" }}
            >
              {" "}
              &times;{" "}
            </span>
          </button>
        </div>

        <div className="modal-body hide-bottom-scrollbar ps-3 pe-0 pt-0">
          <Row className="gx-4 justify-content-between">
            <Col md="2" className="side-tab h-100 py-3 bd-fixed-sidetab">
              <Nav pills className="flex-column">
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "1",
                    })}
                    onClick={() => {
                      toggleVertical("1")
                    }}
                  >
                    Profile
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "2",
                    })}
                    onClick={() => {
                      toggleVertical("2")
                    }}
                  >
                    Revision History
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    style={{ cursor: "pointer" }}
                    className={classnames({
                      "mb-2": true,
                      active: verticalActiveTab === "3",
                    })}
                    onClick={() => {
                      toggleVertical("3")
                    }}
                  >
                    Activity Log
                  </NavLink>
                </NavItem>
              </Nav>
            </Col>
            <Col md="10" className="bd-right-side-tab">
              <div className="px-4 h-100 pl-0">
                <TabContent
                  activeTab={verticalActiveTab}
                  className="text-muted mt-4 mt-md-0"
                >
                  <TabPane tabId="1">
                    <ViewProfile view_proposal={view_proposal} />
                  </TabPane>
                  <TabPane tabId="2">
                    <ViewRevision proposal_revision={proposal_revision} />
                  </TabPane>
                  <TabPane tabId="3">
                    <ViewActivity proposal_activity={proposal_activity} />
                  </TabPane>
                </TabContent>
              </div>
            </Col>
          </Row>
        </div>
      </Modal>

      {/* Proposal Response Modal */}
      <Modal size="md" centered isOpen={responseModal} toggle={() => setResponseModal(false)}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">
            Proposal Declined — Client Response
          </h5>
          <button
            type="button"
            onClick={() => setResponseModal(false)}
            className="btn-modal-close ms-auto"
          >
            <span className="btn-modal-span">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="bg-light rounded p-3 mb-3">
            <p className="fw-bold text-muted mb-1" style={{ fontSize: "12px", textTransform: "uppercase", letterSpacing: "0.5px" }}>
              Reason for Declining
            </p>
            <br></br>
            <p className="text-dark mb-0" style={{ fontSize: "13px" }}>
              {selectedResponse?.reason || "No reason provided"}
            </p>
          </div>
          {selectedResponse?.responded_at && (
            <p className="text-muted mb-0" style={{ fontSize: "12px" }}>
              <i className="fas fa-clock me-1"></i>
              Responded on: {new Date(selectedResponse.responded_at).toLocaleString()}
            </p>
          )}
        </div>
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={() => setResponseModal(false)}
          >
            Close
          </button>
        </div>
      </Modal>

      {/* Access Denied */}

      <AccessDeniedPopup
        modal_Access={modal_Access}
        setAccessDenied={setAccessDenied}
      />
    </React.Fragment>
  )
}

export default Proposal
